"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressValid = void 0;
const addressValid = (address) => {
    if (!address)
        return false;
    const { city, country, formattedAddress, id, } = address;
    if ((typeof city === 'string')
        && (typeof country === 'string')
        && (typeof formattedAddress === 'string')
        && id) {
        return true;
    }
    return false;
};
exports.addressValid = addressValid;
